define(['jquery', 'jquery.transit', 'modernizr', 'container', 'preloader'],
    function($, transit, modernizr, container, preloader)
    {

        return (function() {

            const model = container.getBaseModel();
            const view = container.getBaseView();
            //const pubSub = container.getPublishSubscribe();
            /* model */

            model.publicVars = {
            };

            model.privateVars = {
            };

            model.methods = {

            };

            /* view */

            view.publicVars = {
            };

            view.privateVars = {
                lang: {
                    menuOpen: false
                }
            };

            view.startup = function() {

            };

            view.bind = function() {
                $(view.publicVars.cssId.lang.headerLangMenuCurrentId).click(function () {
                    view.methods.lang.handleMenu();
                });

                $(document).click(function (e) {
                    let container = $(view.publicVars.cssId.lang.headerLangMenuId);
                    const width = $(window).width();

                    if (!container.is(e.target) // if the target of the click isn't the container...
                        && container.has(e.target).length === 0
                        && view.privateVars.lang.menuOpen) // ... nor a descendant of the container
                    {
                        view.methods.lang.handleMenuClose();
                    }
                });
            };

            view.methods = {
                lang: {
                    handleMenu: () => {
                        if(!view.privateVars.lang.menuOpen) {
                            view.methods.lang.handleMenuOpen();
                        } else {
                            view.methods.lang.handleMenuClose();
                        }
                    },

                    handleMenuOpen: () => {
                        $(view.publicVars.cssId.lang.headerLangMenuId).addClass(view.publicVars.cssId.lang.isOpenCls.substr(1));
                        view.privateVars.lang.menuOpen = true;
                    },

                    handleMenuClose: () => {
                        $(view.publicVars.cssId.lang.headerLangMenuId).removeClass(view.publicVars.cssId.lang.isOpenCls.substr(1));
                        view.privateVars.lang.menuOpen = false;
                    }
                }
            };

            /* custom events */
            //pubSub.subscribe('view/showThx', view.methods.showThx);


            /* public methods */
            return {
                init: function(options) {
                    model.init(options);
                    view.init(options);
                }
            };


        })();

    });